module.exports = __webpack_public_path__ + "static/media/lora_modbus_en.e84a5781.md";